<template>
  <v-container class="fill-height justify-center align-center">
    <ChangePasswordCard
      :is-loader-shown="isLoaderShown"
      @on-change="changePassword"
    />
  </v-container>
</template>

<script lang="ts" setup>
  // Import components
  import ChangePasswordCard from '@/pages/auth/partials/ChangePasswordCard.vue';
  // Import composables
  import useAuth from '@/composables/useAuth/useAuth';
  import { useNotificationStore } from '@/store/notificationStore';
  import { ref } from 'vue';
  // import types
  import ApiLoginResponse from '@/types/ApiLogInResponse';

  const auth = useAuth();
  const notificationStore = useNotificationStore();

  const isLoaderShown = ref(false);

  let changePassword = (e: { password: string; newpassword: string }) => {
    const userId: string = auth.getUser?.id?.toString() as string;
    isLoaderShown.value = true;
    const fetch = auth.changeUserPassword(userId, e.password, e.newpassword);

    fetch.onFetchError(() => {
      let errorMessage = 'Password Change failed. Please try again.';
      notificationStore.addErrorNotification(errorMessage);
    });

    fetch.onFetchFinally(() => {
      let { status, data } = JSON.parse(
        fetch.data.value as string
      ) as ApiLoginResponse;
      isLoaderShown.value = false;

      if (status === 'fail') {
        let errorMessage = 'Password change failed. ' + String(data);
        notificationStore.addErrorNotification(errorMessage);
      }
    });
  };
</script>
